import PolicyContainer from "./PolicyContainer";
import { Link } from "../general";
import { 
    PROJECT_NAME,
    PROJECT_DOMAIN, 
    CONTACT_EMAIL,
} from "../../config";

const LAST_UPDATED_DATE = '19.02.2025';

const TermsConditions = () => {
    return (
        <PolicyContainer 
            title='Terms and Conditions'
            body={
                <>
                    <strong>Last Updated: </strong>{LAST_UPDATED_DATE}<br/><br/>

                    Welcome to <strong>{PROJECT_NAME}</strong> (“we,” “us,” or “our”). These Terms and Conditions govern your access to and use of <strong>{PROJECT_NAME}</strong> (<Link href={`https://${PROJECT_DOMAIN}`}>{PROJECT_DOMAIN}</Link>) (the “Website” or "Service"). By using our Service, you agree to comply with and be bound by these Terms. If you do not agree, please do not use our Service.

                    <h2>1. Acceptance of Terms</h2>
                    By accessing or using <strong>{PROJECT_NAME}</strong>, you confirm that you have read, understood, and agree to these Terms and our <Link href='/privacy'>Privacy Policy</Link>.

                    <h2>2. User Eligibility & Account Registration</h2>
                    You may create an account to access additional features such as tracking and managing links. You are responsible for maintaining the confidentiality of your login credentials and must not share your account with others.

                    <h2>3. Prohibited Use</h2>
                    You agree <strong>not</strong> to use <strong>{PROJECT_NAME}</strong> to:  
                    <ul>
                        <li>Shorten URLs that lead to illegal, harmful, misleading, or malicious content.</li>
                        <li>Engage in spamming, phishing, or fraudulent activities.</li>
                        <li>Circumvent tracking or security measures.</li>
                        <li>Use the service for political manipulation or misinformation.</li>
                        <li>Use automated systems (bots or scripts) to create mass short URLs.</li>
                        <li>Violate any laws or regulations in Lithuania or any other applicable jurisdiction.</li>
                        <li>Infringe on any third-party intellectual property rights.</li>
                    </ul>
                    We reserve the right to <strong>suspend or terminate</strong> accounts and links that violate these rules without prior notice. 
                    If you believe your account was wrongfully suspended, you may contact us at <Link href={`mailto:${CONTACT_EMAIL}`}>{CONTACT_EMAIL}</Link> for review.

                    <h2>4. Link Tracking & Data Collection</h2>
                    By using our Service, you acknowledge that <strong>{PROJECT_NAME}</strong> collects and processes certain data, including tracking and analytics data for security, performance, and fraud prevention purposes.
                    For more details, please review our <Link href='/privacy'>Privacy Policy</Link>.

                    <h2>5. Intellectual Property Rights</h2>
                    <ul>
                        <li><strong>{PROJECT_NAME}</strong> and its associated trademarks, logos, and designs are our property.</li>
                        <li>You may not copy, modify, distribute, or sell any part of our Service without permission.</li>
                    </ul>

                    <h2>6. Disclaimers & Limitation of Liability</h2>
                    <ul>
                        <li><strong>{PROJECT_NAME}</strong> is provided <strong>"as is"</strong> without warranties of any kind.</li>
                        <li>We do <strong>not</strong> guarantee continuous availability of the Service and are <strong>not</strong> liable for damages, data loss, or third-party actions.</li>
                        <li>We are also <strong>not</strong> responsible for failures caused by unforeseeable circumstances beyond our control, including but not limited to natural disasters, wars, or government actions.</li>
                    </ul>

                    <h2>7. Third-Party Links</h2>
                    Shortened links may redirect to third-party websites. <strong>{PROJECT_NAME}</strong> is <strong>not responsible</strong> for the content, security, or policies of those websites. Users are advised to <strong>verify</strong> destination links before clicking.

                    <h2>8. Changes to Terms</h2>
                    We may update these Terms from time to time. Continued use of <strong>{PROJECT_NAME}</strong> after changes means you accept the new Terms.

                    <h2>9. Governing Law & Jurisdiction</h2>
                    These Terms are governed by the laws of <strong>Lithuania</strong>. Any disputes will 
                    be resolved in the courts of <strong>Lithuania</strong>.

                    <h2>10. Contact Us</h2>
                    If you have any questions, please contact us at <Link href={`mailto:${CONTACT_EMAIL}`}>{CONTACT_EMAIL}</Link>.
                </>
            }
        />
    );
}

export default TermsConditions;